<template>
    <div>
        <MainModal :show-modal="showModal" size="sm" :footer="false" @close="$emit('close')">
            <template #body>
                <div class="mb--5 p-4 pt-2 pb-2">
                    <div class="flex align-items-center justify-content-center success__img__wrap">                        
                        <IconSvg name="layer" width="48px" height="48px"  />
                    </div>

                    <div class="mx-auto mt--20">
                        <div>
                            <p class="text-center text--xl text--semi--bold text--upper">
                                Start tracker?
                            </p>

                            <div class="text-center text-gray-600 mt--10 text--sm" style="line-height: 23px;">
                                Timer starts counting after your request is successful. To stop the timer, click on the 
                                <div class="command">
                                    <IconSvg name="dots-horizontal-rounded" fill="#4b5563" />
                                </div> icon on the far top right, scroll down and click on the <div class="command">
                                    <IconSvg name="stop-circle" fill="#4b5563" class="mr--3" />
                                    Stop timer
                                </div>
                                option.
                            </div>
                        </div>
                    </div>

                    <div class="mt--30">
                        <FormLabel title="Pick a start date" />
                        <v-date-picker
                            v-model="form.startDate" class="text--sm" mode="dateTime" borderless
                            is24hr title-position="left" :min-date="new Date()"
                        >
                            <template #default="{ inputValue, inputEvents }">
                                <input
                                    class="px-2 py-1 border rounded due_date form-control form-control-sm text--sm"
                                    :value="inputValue"
                                    nav-visibility="click"
                                    v-on="inputEvents"
                                >
                            </template>
                        </v-date-picker>
                    </div>

                    <div class="footer-modal w-100 mx-auto">
                        <BaseButton 
                            label="Cancel"
                            :disabled="loading" 
                            variant="outline"
                            variant-style="secondary"
                            class="mr--5"
                            @submit="$emit('close')"
                        />
                        <BaseButton 
                            label="Schedule"
                            :disabled="!form.startDate" 
                            :loading="loading" 
                            @submit="scheduleProjectStart"
                        />
                    </div>
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import BaseButton from "../buttons/BaseButton.vue";
import FormLabel from "../forms/FormLabel.vue";
import IconSvg from "../icons/Icon-Svg.vue";
import NonLinkedTab from "../tabs/NonLinkedTab.vue";
import NonLinkedTabs from "../tabs/NonLinkedTabs.vue";
import MainModal from "./MainModal.vue";

export default {
    name: "ScheduleProjectModal",

    components: {
        MainModal,
        IconSvg,
        BaseButton,
        FormLabel,
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        projectId: { type: String, default: "" },
    },

    data() {
        return {
            form: {
                startDate: null,
            },
            loading: false,
        };
    },

    methods: {
        async scheduleProjectStart() {
            try {
                this.loading = true;
                
                const payload = {
                    trackingType: "scheduled_tracker",
                    startDate: new Date(this.form.startDate)?.getTime(),
                    trackProject: true,
                };

                await this.$store.dispatch("project/scheduleProject", { payload, id: this.projectId });
                
                this.form.startDate = null;
                this.$emit("close");
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;
                this.$toast.error(errMsg);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.success__img__wrap {
    position: relative;
}

.footer-modal {
    font-size: 18px;
    font-weight: 500; 
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 25px;
}
</style>